import apiClient from '../axiosConfig';
import { components } from '../types/openapi';

// Tipos del OpenAPI
type AppVersionResponse = components['schemas']['AppVersionResponse'];
type CreateAppVersion = components['schemas']['CreateAppVersion'];
type UpdateAppVersion = components['schemas']['UpdateAppVersion'];
type PaginationAppVersionResponse = components['schemas']['Pagination_AppVersionResponse_'];
type CheckAppVersion = components['schemas']['CheckAppVersion'];

/**
 * Servicio de gestión de versiones de APK
 * Maneja todas las operaciones CRUD de versiones de aplicación
 * Basado en los endpoints del OpenAPI
 */
class AppVersionService {
  /**
   * Crear una nueva versión de APK
   * POST /api/core/app-versions/
   */
  async createAppVersion(data: CreateAppVersion): Promise<AppVersionResponse> {
    const response = await apiClient.post<AppVersionResponse>('/core/app-versions/', data);
    return response.data;
  }

  /**
   * Actualizar una versión de APK
   * PUT /api/core/app-versions/
   */
  async updateAppVersion(data: UpdateAppVersion): Promise<AppVersionResponse> {
    const response = await apiClient.put<AppVersionResponse>('/core/app-versions/', data);
    return response.data;
  }

  /**
   * Obtener versiones con paginación
   * GET /api/core/app-versions/pagination
   */
  async getAppVersionsPaginated(params?: {
    page?: number;
    limit?: number;
    version?: string | null;
  }): Promise<PaginationAppVersionResponse> {
    const response = await apiClient.get<PaginationAppVersionResponse>('/core/app-versions/pagination', { params });
    return response.data;
  }

  /**
   * Verificar versión de aplicación
   * GET /api/core/app-versions/check/{version}
   */
  async checkAppVersion(version: string): Promise<CheckAppVersion> {
    const response = await apiClient.get<CheckAppVersion>(`/core/app-versions/check/${version}`);
    return response.data;
  }

  /**
   * Eliminar una versión de APK
   * DELETE /api/core/app-versions/{version_id}
   */
  async deleteAppVersion(versionId: number): Promise<unknown> {
    const response = await apiClient.delete(`/core/app-versions/${versionId}`);
    return response.data;
  }

  /**
   * Cambiar estado de una versión (activar/desactivar)
   * PUT /api/core/app-versions/change-state/{version_id}
   */
  async changeAppVersionState(versionId: number): Promise<AppVersionResponse> {
    const response = await apiClient.put<AppVersionResponse>(`/core/app-versions/change-state/${versionId}`);
    return response.data;
  }
}

export default new AppVersionService();

